// ══════════════════════════════════════════════════════
//  judgments/valuationRatios.js — 估值倍数定性判断
//
//  合约：所有 judge* 函数遇到 null 输入返回 null（不抛错）
// ══════════════════════════════════════════════════════

import { safeNum } from '../extractors/_shared';

const buildJudgment = (emoji, labelZh, labelEn, positive) => ({ emoji, labelZh, labelEn, positive });

/** MC / 年化收入：协议估值核心锚点 */
export function judgeMcRev(ratio) {
  const r = safeNum(ratio);
  if (r == null) return null;
  if (r < 15)  return buildJudgment('🟢', '估值偏低', 'Cheap',       true);
  if (r < 30)  return buildJudgment('🟢', '估值合理', 'Fair',        true);
  if (r < 50)  return buildJudgment('🟡', '估值中性', 'Neutral',     null);
  if (r < 100) return buildJudgment('🟠', '估值偏高', 'Rich',        false);
  return         buildJudgment('🔴', '估值过热', 'Overheated', false);
}

/** FDMC / 年化收入：包含未解锁筹码的全摊薄估值 */
export function judgeFdvRev(ratio) {
  const r = safeNum(ratio);
  if (r == null) return null;
  if (r < 25)  return buildJudgment('🟢', '全摊薄合理', 'Fair (FD)',    true);
  if (r < 60)  return buildJudgment('🟡', '全摊薄中性', 'Neutral (FD)', null);
  if (r < 120) return buildJudgment('🟠', '全摊薄偏高', 'Rich (FD)',    false);
  return         buildJudgment('🔴', '全摊薄过热', 'Overheated (FD)', false);
}

/** P/S = FDV / 年化手续费 */
export function judgePS(ratio) {
  const r = safeNum(ratio);
  if (r == null) return null;
  if (r < 5)   return buildJudgment('🟢', '极低估值',   'Very cheap', true);
  if (r < 20)  return buildJudgment('🟢', '合理',       'Fair',       true);
  if (r < 50)  return buildJudgment('🟡', '存在溢价',   'Premium',    null);
  if (r < 100) return buildJudgment('🟠', '高估',       'Expensive',  false);
  return         buildJudgment('🔴', '严重高估',   'Overheated', false);
}
